<p class="graph-title font-primary--b">{{title | translate}}</p>
<div
  class="graph-wrapper {{ chartCategory }}"
  [class.default]="default"
  [class.chart-container]="isInDashboard"
  [class.unsubscribed]="!subscribed"
  [class.wideMode]="wideMode"
  *ngIf="!isEmpty"
>
  <canvas #{{chartCategory}} id="{{ chartCategory }}"></canvas>
  <div class="unsubscribed-card" *ngIf="!subscribed && showUnsubscribedCard">
    <p class="description">
      {{ description }}
    </p>
    <div class="text-end">
      <a
        class="mt-2 ms-auto d-block text-red"
        routerLink="/dashboard/membership"
      >
        {{ "chartLabels.unlock-statistics-button" | translate }}
      </a>
    </div>
  </div>
</div>
<div *ngIf="isEmpty">
  <h1 class="graph-title graph-title-no-data"> {{ "chartLabels.no-data" | translate}} </h1>
</div>
<!-- <button (click)="reInitChart()">Reload</button>
<pre>
  {{dataSets  | json}}
  {{labels | json}}
  {{colors | json}}
</pre> -->
